import React, { useEffect } from "react";
import clsx from "clsx/lite";
import ButtonLink from "components/button-link";
import ProductCard from "./product-card";
import { useCustomer } from "hooks/useStore";
import { useInView } from "react-intersection-observer";
import { trackViewItemList } from "analytics";

const SingleCollection = ({ data }) => {
	const { ref, inView } = useInView({ threshold: 0, triggerOnce: true });
	const { collection, itemsToShow = 8, settings, showGridOnMobile, cta, cardStyle, cardStyleMobile, splitDesignByDevice,
		collectionMobile  } = data || {};
	const SingleCollection = splitDesignByDevice ? collectionMobile : collection;
	const products = SingleCollection?.products || [];
	const title = data?.title || SingleCollection?.title;
	const customer = useCustomer();
	const selectedCardStyle = cardStyleMobile || cardStyle;
	useEffect(() => {
		if (inView)
			trackViewItemList(products, { title, handle: location.pathname }, customer);

	}, [inView]);
	if (!SingleCollection || !products.length) return null;
	

	return (
		<div ref={ref} className="w-full flex flex-col items-center gap-4 md:gap-8 featured-collection-v1">
			<h3
				className={clsx(
					"capitalize horizontal-padding font-header text-xxl sm:text-[30px]",
					settings?.useLatoTitleFont && "text-3xl lg:text-5xl font-base font-medium"
				)}
			>
				{title}
			</h3>

			<div className="w-full text-center overflow-hidden">
				<ul
					className={clsx(
						"featured-collection",
						itemsToShow === 4 ? "flex lg:inline-grid" : "featured-collection-large",
						settings?.isFluid && "horizontal-padding",
						showGridOnMobile && "grid-featured-collection"
					)}
				>
					{products.slice(0, itemsToShow).map((product, index) => (
						<li key={product.id || index} className="w-fit pb-2 md:pb-0">
							<ProductCard product={product} cardStyle={selectedCardStyle} />
						</li>
					))}
				</ul>
			</div>

			<div className="w-full flex justify-center shop-all-button">
				<ButtonLink data={cta} />
			</div>
		</div>
	);
};

export default SingleCollection;
